// extracted by mini-css-extract-plugin
export default {"aboutContainer":"AboutUs_aboutContainer__xQ4oM"};